import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
    TimeSeriesScale
} from 'chart.js';
import 'chartjs-adapter-date-fns'; // برای پشتیبانی از مقیاس زمانی

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
    TimeSeriesScale
);

const Chart2 = ({dataPoints}) => {
    const data = {
            labels: dataPoints.map(point => point.createdTime),
        datasets: [
            {
                label: 'فاصله زمانی (دقیقه)',
                data: dataPoints.map(point => point.periodSinceLastCreated),
                fill: true,
                borderColor: 'rgb(75, 192, 192)',
                tension: 0.1
            }
        ]
    };

    const options = {
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'hour',
                    tooltipFormat: 'HH:mm'
                },
                title: {
                    display: true,
                    text: 'زمان'
                }
            },
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'فاصله زمانی (دقیقه)'
                }
            }
        },
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `${context.parsed.y} دقیقه`;
                    }
                }
            }
        }
    };

    return <Line data={data} options={options} />;
};

export default Chart2;
